// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Zv-z","tooltipWrapper":"_v-z","icon":"aw-z","tooltip":"bw-z","content":"cw-z"};